import {
  StyledNoticeModalBody,
  StyledBlueButton,
  StyledButton,
  StyledButtonField,
  StyledExplainText,
  StyledTitleText,
  StyledNoticeModalHeader,
} from "./Style";
import { useAppDispatch, useAppSelector } from "@/hooks/redux";
import { MODAL_NAME } from "./constants";
import { projectActions } from "@/redux/stores/projectStore";
import { getDashBoardState, getProjectState } from "@/redux/store";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import styled from "styled-components";
import { Image, Modal, notification } from "antd";
import { ButtonTextDiv } from "@/styles/Button";
import { UpgradeIcon } from "@/components/common/Icons";
import { useSession } from "next-auth/react";
import { useCookies } from "react-cookie";
import { useCallback, useState } from "react";
import { requestUpgradePlanToMaster } from "@/lib/workspace-util";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { useGetUserInfoQuery } from "@/redux/api/userApi";


const StyledModal = styled(Modal)`

  .ant-modal-content {
    padding: 0px;
    display: flex;
    border-radius: 5px;
    .ant-modal-body {
      border-radius: 5px;
      width: 100%;
    }
  }
`;

export const NoticeModal = () => {
  const { t } = useTranslation("common");
  const session = useSession();

  const { data: userInfo } = useGetUserInfoQuery(
    {},
    {
      pollingInterval: 30 * 60 * 1000,
      refetchOnFocus: true,
      refetchOnMountOrArgChange: true,
      refetchOnReconnect: true,
      skip: false,
    }
  );
  const isUnlimitedCredits = userInfo?.plan === 'none' || (userInfo?.plan?.toLocaleLowerCase()?.includes('unlimited')) || userInfo?.enterprise;

  const router = useRouter();

  const openedModal = useAppSelector(
    (store) => getProjectState(store).openedModal
  );
  const noticeTitle = useAppSelector(
    (store) => getProjectState(store).noticeTitle
  );
  const noticeExplains = useAppSelector(
    (store) => getProjectState(store).noticeExplains
  );
  const modalTitle = useAppSelector(
    (store) => getProjectState(store).modalTitle
  );
  const modalLogoUrl = useAppSelector(
    (store) => getProjectState(store).modalLogoUrl
  );

  const { decryptParams, buttonText } = useAppSelector((store) => getProjectState(store) ?? false);

  const [cookies, setCookie] = useCookies(["first_page_view_pricing"]);

  const { setOpenedModal, setCurrentPlanAndOpenedModal } = projectActions;
  const dispatch = useAppDispatch();

  const { workspaceList, selectedWorkspaceIndex, accountUserInfo } = useAppSelector((store) => getDashBoardState(store) ?? false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const closeModal = () => {
    if (
      router.query?.openSubscribe === "true" ||
      router.query?.openCheckout === "true"
    ) {
      window.location.replace(window.location.pathname);
    }
    dispatch(setOpenedModal(MODAL_NAME.NONE));
  };

  const onClickOk = () => {
    if (session.status === "unauthenticated") {
      dispatch(setOpenedModal(MODAL_NAME.LOGIN));
      return;
    }

    if (!cookies?.first_page_view_pricing) {
      setCookie("first_page_view_pricing", true, { path: "/" });
      window.dataLayer.push({
        event: "first_page_view_pricing",
        location: "modal",
      });
    }

    if (window?.dataLayer?.push) {
      window.dataLayer.push({
        event: "page_view_pricing",
        location: "modal",
      });
    }

    if(isUnlimitedCredits){
      dispatch(setOpenedModal(MODAL_NAME.SUBSCRIPTION_LIST));
    }else{
      const payload = {
        currentPlan: accountUserInfo?.plan,
        openedModal: MODAL_NAME.PLAN_SWITCH,
      };
  
      dispatch(setCurrentPlanAndOpenedModal(payload));
    }
  };

  const handleRequestUpgrade = useCallback(async() => {
    console.log(`--------- handleRequestUpgrade init ---------`);
    try {
      setIsLoading(true);
      await requestUpgradePlanToMaster({
        workspaceId: workspaceList[selectedWorkspaceIndex].workspaceId,
        email: accountUserInfo?.id,
        companyId: workspaceList[selectedWorkspaceIndex].companyId,
        templateName: 'requestUpgradePlanToMaster',
        workspaceName: workspaceList[selectedWorkspaceIndex].workspaceName,
        toEmail: accountUserInfo?.masterUserInfo?.id,
      }).then((result) => {
        console.log(`requestUpgradePlanToMaster result `, {result})
        if(result?.data?.success) {
          setIsLoading(false);
          dispatch(setOpenedModal(MODAL_NAME.NONE));
          notification.success({
            message: <span style={{ color: '#ffffff'}}>{t('Your request email has been sent successfully.')}</span>,
            duration: 4,
            placement: 'top',
            style: {
              width: '700px',
              backgroundColor: '#2bab62',
              position: 'relative',
              borderRadius: '12px',
              padding: '13px 30px',
            }
          });
        }
      }).catch((error) => {
        console.error(`requestUpgradePlanToMaster error `, {error});
        const errorMessage = error?.message || 'Request Upgrade Email error';
        setIsLoading(false);
        alert(t(`${errorMessage}`));
        dispatch(setOpenedModal(MODAL_NAME.NONE));
      })

    } catch(error) {
      console.error(`handleRequestUpgrade error `, {error});
      const errorMessage = error?.message || 'Request Upgrade Email error';
      setIsLoading(false);
      alert(t(`${errorMessage}`));
      dispatch(setOpenedModal(MODAL_NAME.NONE));
    } finally {
      setIsLoading(false);
    }
  }, [accountUserInfo, dispatch, selectedWorkspaceIndex, setOpenedModal, t, workspaceList]);

  const handleRequestAccess = useCallback(async() => {
    console.log(`--------- handleRequestAccess init ---------`);
    if(!decryptParams) {
      console.log(`--------- handleRequestAccess noParams ---------`);
      notification.error({
        message: <span style={{ color: '#ffffff'}}>{t('Request Access Seats Email Failed')}</span>,
        duration: 4,
        placement: 'top',
        style: {
          width: '700px',
          backgroundColor: 'red',
          position: 'relative',
          borderRadius: '8px',
          padding: '13px 30px',
        },
        closeIcon: <span style={{ color: '#ffffff'}}>X</span>, 
        icon: <ExclamationCircleOutlined style={{ color: '#ffffff' }} />,
      })
      dispatch(setOpenedModal(MODAL_NAME.NONE));
      return;
    }
    try {
      setIsLoading(true);
      console.log(`--------- handleRequestAccess sendEmail ---------`);
      await requestUpgradePlanToMaster({
        workspaceId: decryptParams.workspaceId,
        email: decryptParams.email,
        companyId: decryptParams.companyId,
        templateName: 'requestUpgradePlanToMaster',
        workspaceName: decryptParams.workspaceName,
        toEmail: decryptParams?.workspaceInfo?.masterUserEmail || decryptParams?.fromEmail,
      }).then((result) => {
        console.log(`requestUpgradePlanToMaster result `, {result})
        if(result?.data?.success) {
          setIsLoading(false);
          dispatch(setOpenedModal(MODAL_NAME.NONE));
          notification.success({
            message: <span style={{ color: '#ffffff'}}>{t('Your request email has been sent successfully.')}</span>,
            duration: 4,
            placement: 'top',
            style: {
              width: '700px',
              backgroundColor: '#2bab62',
              position: 'relative',
              borderRadius: '8px',
              padding: '13px 30px',
            },
            closeIcon: <span style={{ color: '#ffffff' }}>X</span>, 
            icon: <ExclamationCircleOutlined style={{ color: '#ffffff' }} />,
          });
        }
      }).catch((error) => {
        console.error(`requestUpgradePlanToMaster error `, {error});
        const errorMessage = error?.message || 'Request Upgrade Email error';
        setIsLoading(false);
        alert(t(`${errorMessage}`));
        dispatch(setOpenedModal(MODAL_NAME.NONE));
      })

    } catch(error) {
      console.error(`handleRequestUpgrade error `, {error});
      const errorMessage = error?.message || 'Request Upgrade Email error';
      setIsLoading(false);
      alert(t(`${errorMessage}`));
      dispatch(setOpenedModal(MODAL_NAME.NONE));
    } finally {
      setIsLoading(false);
    }
  }, [decryptParams, dispatch, setOpenedModal, t])
  
  return (
    <StyledModal
      width={480}
      open={openedModal === MODAL_NAME.NOTICE}
      centered
      footer={null}
      closable={false}
      onCancel={closeModal}
      zIndex={1002}
    >
      <StyledNoticeModalHeader>
        <div className="header-root">
          <div className="header-content">
            <span className="item">
              <Image src={modalLogoUrl} alt="" preview={false} />
            </span>
            <span className="item" style={{ position: "relative", top: "2px" }}>
              {t(modalTitle)}
            </span>
          </div>
        </div>
      </StyledNoticeModalHeader>
      <StyledNoticeModalBody>
        <StyledTitleText>{noticeTitle}</StyledTitleText>
        {noticeExplains.map((explainText) => (
          <StyledExplainText key={explainText}>{explainText}</StyledExplainText>
        ))}
        <StyledButtonField>
          <StyledButton onClick={closeModal}>{t("Maybe later")}</StyledButton>
          {workspaceList.length > 0 && workspaceList[selectedWorkspaceIndex]?.userType !== 'master'
          ? <StyledBlueButton onClick={handleRequestUpgrade}>
            <ButtonTextDiv gap={5}>
              {/* <span className="item">
                <UpgradeIcon width={19} height={17} fill="white" />
              </span> */}
              <span className="item">{t("Request Upgrade")}</span>
            </ButtonTextDiv>
          </StyledBlueButton>
          : <StyledBlueButton onClick={(event) => {
            event.stopPropagation();
            event.preventDefault();
            if(buttonText !== '') {
              handleRequestAccess();
            } else {
              onClickOk();
            }
          }}>
            <ButtonTextDiv gap={5}>
              <span className="item">
                {(workspaceList[selectedWorkspaceIndex]?.userType === 'member' 
                  || workspaceList[selectedWorkspaceIndex]?.userType === 'admin'
                ) ? null
                : <UpgradeIcon width={19} height={17} fill="white" />}
              </span>
              <span>{buttonText !== '' ? buttonText : t('Upgrade Plan')}</span>
              {/* <span className="item">{t("Upgrade plan")}</span> */}
            </ButtonTextDiv>
          </StyledBlueButton>}
        </StyledButtonField>
      </StyledNoticeModalBody>
    </StyledModal>
  );
};
